export default __webpack_public_path__ + "static/media/pdf_icon.3ffbb0e1.svg";